module.exports = __webpack_public_path__ + "img/thirtytwo.00cbbf27.png";